import classNames from 'classnames';
import Form from 'next/form';
import { ChangeEvent, FC, useActionState, useEffect, useState } from 'react';

import { postCartPromo } from '@/entities/promo';
import { EMAIL_RSS_ICONS } from '@/features/rss/ui/emailRss/config';
import { IconName, Input } from '@/shared/ui';

import styles from './promoInput.module.scss';

type PromoInputProps = {
  className?: string;
};

const PromoInput: FC<PromoInputProps> = (props) => {
  const { className } = props;
  const [state, dispatch] = useActionState(postCartPromo, {
    success: false,
    message: '',
    fieldErrors: { email: '' },
  });
  const [inputValue, setInputValue] = useState('');
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (state.success) {
      setInputValue('');
      setValidationError('');
    } else {
      setValidationError(state?.message ?? '');
    }
  }, [state]);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = e.target.value;
    setInputValue(value);

    if (validationError) {
      setValidationError('');
    }
  };

  const currentIcon = state.success
    ? EMAIL_RSS_ICONS.success
    : EMAIL_RSS_ICONS.default;

  return (
    <Form
      action={dispatch}
      className={classNames(styles.inputPromo, className)}
    >
      <Input
        className={styles.inputPromo__text}
        disabled={state.success}
        error={validationError}
        name="code"
        placeholder="Промокод"
        rightIcon={currentIcon as IconName}
        value={inputValue}
        onChange={handleInputChange}
      />
    </Form>
  );
};

PromoInput.displayName = 'PromoInput';

export default PromoInput;
